export const convertToDecimalNumber = (value: number) => {
  return Number(Number(value).toFixed(2))
}
